import User from "./User";
import Game from "./Game";
import World from "./World";
import Events from "./Events"
import GameState from "./GameState";
import Cue from "./Cue";

let gameInitialized = false;

export function startup(placeholderRef: HTMLElement) {
    if(gameInitialized) return;

    GameState.posicaoBranca = {x: -1, y: 9, z: -1};
    GameState.horizontalSpeed = 10.0 / 360;
    GameState.verticalSpeed = 10.0 / 360;
    GameState.cameraDistance = 10;

    //TODO: implement dialogs as react
    // Dialogs.Init();

    //TODO: Rethink authentication
    // User.Init(function(){
    // 	Channel.Init();
    // 	Menu.Init();
    // });
    User.user = {};

    // Room.GetAll(function(rooms){
    // 	Room.Display(rooms);
    // });

    //TODO: implement anaglyph as react
    // $("#anaglyph-button").click(function () {
    //     Game.Config.Anaglyph = !Game.Config.Anaglyph;
    // });

    Game.InitResources(placeholderRef);
    World.Init();
    let sceneLoadedPromise = Game.InitScene();
    Game.InitLights();
    Game.InitCamera();
    Events.Init();
    sceneLoadedPromise.then(() => {
        (function animate() {
            requestAnimationFrame(animate);
            Cue.Tracker.frame(performance.now());   // lets the stroke tracker tell a browser stall from a paused hand
            Game.UpdateState();
            Game.UpdateCamera();
            Game.Render();
        })();
    });

    gameInitialized = true;
};

